import { Autocomplete, createFilterOptions, TextField } from '@mui/material';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getEMerchant } from 'redux/reducers/monthlyFee/selectors';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { COLORS } from 'services/constants/colors';

const filterOptions = createFilterOptions<string>({
	ignoreCase: true,
	matchFrom: 'any',
});

export const EmFilter = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);
	const { searchEmId } = navigateParams;

	const emList = useSelector(getEMerchant);
	const emListFullNames = useMemo(() => {
		const names = emList?.map((item) => item.fullName) ?? [];
		return [...new Set(names)];
	}, [emList]);
	const [inputEm, setInputEm] = useState(
		emList?.find((item) => item.id === Number(navigateParams.emId))?.fullName || '',
	);
	const handleChangeEm = (event: any, newValue: string | null) => {
		setInputEm(newValue ?? '');
		const newSearchEmId = emList?.find((item) => item.fullName === newValue)?.id;
		navigate({
			pathname: location.pathname,
			search: `?${queryString.stringify({
				...navigateParams,
				searchEmId: newSearchEmId,
				page: 1,
			})}`,
		});
	};

	const handleInputChange = (event: any, newInputValue: string) => {
		setInputEm(newInputValue);
	};
	return (
		<Autocomplete
			options={emListFullNames}
			filterOptions={filterOptions}
			sx={{
				width: '300px',
				mr: 0.5,
				'& .MuiOutlinedInput-notchedOutline': {
					border: `1px solid ${COLORS.PRIMARY}`,
				},
				'& .MuiAutocomplete-clearIndicator': {
					color: COLORS.PRIMARY,
				},
				'& .MuiAutocomplete-popupIndicator': {
					color: COLORS.PRIMARY,
				},
			}}
			inputValue={inputEm}
			onInputChange={handleInputChange}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					sx={{
						ml: 0,
						flex: 1,
						fontSize: '.9rem',
						height: '28px',
						p: '0px 0px',
						'& input': {
							padding: '0px 0px',
							margin: '0px',
							fontSize: '.8rem',
							height: '11px!important',
							color: COLORS.PRIMARY,
							fontWeight: 'bold',
							'&::placeholder': {
								fontSize: '.8rem',
								fontWeight: 'normal',
							},
						},
					}}
					placeholder="Search EM"
					size="small"
				/>
			)}
			value={emList?.find((item) => item.id === Number(searchEmId))?.fullName || null}
			onChange={handleChangeEm}
		/>
	);
};
